"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  equipmentFee: {
    title: '箱管 / 用箱查询',
    blNo: '提单号',
    containerNo: '箱号',
    exportExcel: '导出',
    tips_1: '温馨提示：',
    tips_2: '（1） 本系统查询结果仅供参考，不能作为最后付费依据; 无法查询到结果的集装箱不代表未产生费用。',
    tips_3: '（2） 本系统仅提供滞期费和修箱费的查询，集装箱超期使用后可能在码头、堆场产生的堆场费、查验费、搬移费、罚款等，将由相关单位根据有关规定收取',
    tips_4: '（3） 滞期费根据海丰集装箱运输有限公司对外公布的费率据实计收，具体费率和计收方式可以联系海丰集装箱运输有限公司当地代理咨询。',
    tips_5: '（4） 滞期费红色字体，数据截止为未还箱的费用。',
    tips_6: '（5） 修箱费页面所显示的箱损图片为堆场验箱时所发现的所有箱损部位，并非是指向客户收费的项目。',
    tips_7: '（6） 修箱费页面，堆场判断需要向客户收费的项目请参见“明细”，并以口岸实际发送账单为准。',
    tips_8: '（7） 如对堆场判定的修箱费结果有异议，请与我司当地口岸公司进口箱管部门联系。',
    DEMDETFeeTotal: '滞期费总额：',
    repairFeeTotal: '修箱费总额：',
    DEMDETFee: '滞期费',
    repairFee: '修箱费',
    noData: '暂无数据，无法导出Excel',
    DEMFee: 'DEM费用明细',
    DETFee: 'DET费用明细',
    containerType: '箱型',
    port: '发生港口',
    startDate: '开始日期',
    effectiveDate: '有效期',
    endDate: '截至日期',
    freeDays: '免费天数',
    days: '用箱天数',
    overDays: '超期天数',
    amount: '金额',
    currency: '币种',
    ftNo: 'FTNo',
    demDetSum: '总用箱天数',
    totalSum: '总金额',
    sysEndDate: '系统内计算日期',
    startDay: '起始天数',
    endDay: '结束天数',
    containerInfo: '集装箱信息',
    fixedCosts: '固定费用',
    chargeByLevel: '按等级收取列表',
    demuFreeDays: 'Demurrage 免费天数',
    detenFreeDays: 'Detention 免费天数',
    demTotal: 'DEM 合计',
    detTotal: 'DET 合计',
    repairPicture: '修箱图片',
    state: '状态',
    total: '合计',
    applying: '申请中',
    approved: '已审批',
    refuse: '拒绝',
    underApproval: '审批中',
    componentCode: '构件',
    repairLocationCode: '部位',
    damageCode: '损坏',
    repairCode: '维修',
    applyType: '申请类型',
    applyFee: '减免/退费金额',
    applyDate: '申请日期',
    repairFeeDetail: '修箱费详情',
    process: '减免/退费进度',
    derate: '减免',
    refund: '退费',
    detailInfo: '明细',
    info: '信息查询',
    blNoInner: '提单号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;',
    containerNoInner: '箱号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;',
    containerTypeInner: '箱型&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;',
    amountInner: '金额&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;',
    voyageRateInner: '汇率&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;',
    stateInner: '状态&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;',
    chargeFee: '插电费',
    endDate1: '截止日期',
    rate: '费率',
    invoiceAmout: '已缴费',
    pickupDate: '预计提箱日期'
  }
};